module.exports = __webpack_public_path__ + "img/sq.8809402c.webp";